import { css } from '@flipster/styled-system/css';

/**
 * 포지션 테이블(open/pending 공용) td/th 레이아웃 + 마지막 컬럼 sticky.
 * 구 positionTable.module.scss의 `.table` 규칙을 Panda로 이관한 것. ui Table의 className으로 전달한다.
 *
 * 패딩은 `!important`로 지정한다: @flipster/ui Table이 `.wrapper table td:first-child` 등
 * 높은 specificity로 기본 셀 패딩(16px/8px)을 갖고 있어, Panda 원자 클래스만으론 못 덮기 때문.
 * (구 SCSS는 `.wrapper .table td` 2-클래스 prefix로 specificity를 이겨서 덮었었다.)
 */
export const positionTableCss = css({
  '& th': { p: '12px!', letterSpacing: '0.02em' },
  '& td': { px: '12px!', py: '8px!', border: 'none!' },
  '& td, & th': { boxSizing: 'content-box' },
  '& td:first-child, & th:first-child': { pl: '0!' },
  '& td:last-child, & th:last-child': {
    position: 'sticky',
    right: 0,
    pr: '12px!',
    bg: 'gray.0',
    transition: 'box-shadow 0.15s ease',
  },
});
